import { CustomerSettingsDatagrid } from '../../components/DataGrid/CustomerSettings';

export const CustomerSettingPage = () => {
  return (
    <>
      <CustomerSettingsDatagrid />
    </>
  );
};
